import React, { useState } from 'react';
import { Star, CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
export function LeaveReview() {
  const [rating, setRating] = useState(5);
  const [hoverRating, setHoverRating] = useState(0);
  const [review, setReview] = useState('');
  const [name, setName] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (review.trim() && name.trim()) {
      setIsSubmitted(true);
    }
  };
  return <section className="w-full py-20 px-4 bg-[#0a0a0a]" data-id="element-192">
      <div className="max-w-2xl mx-auto" data-id="element-193">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-b from-[#111] to-[#0a0a0a] border border-white/10 rounded-3xl p-8 sm:p-12 shadow-[0_0_30px_rgba(0,0,0,0.5)] relative overflow-hidden" data-id="element-194">
          {/* Subtle glow */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[300px] h-[300px] bg-[#D4AF37]/5 rounded-full blur-[80px] pointer-events-none" data-id="element-195" />

          <div className="relative z-10" data-id="element-196">
            {isSubmitted ? <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} className="flex flex-col items-center text-center py-8" data-id="element-197">
                <div className="w-16 h-16 rounded-full bg-[#D4AF37]/20 flex items-center justify-center mb-6" data-id="element-198">
                  <CheckCircle2 className="w-8 h-8 text-[#D4AF37]" data-id="element-199" />
                </div>
                <h3 className="font-playfair text-2xl sm:text-3xl text-white mb-4" data-id="element-200">
                  ¡Gracias por compartir tu experiencia!
                </h3>
                <p className="font-inter text-gray-400" data-id="element-201">
                  Tu testimonio ha sido enviado y será revisado pronto.
                </p>
              </motion.div> : <>
                <div className="text-center mb-8" data-id="element-202">
                  <h2 className="font-playfair text-3xl sm:text-4xl text-white mb-3" data-id="element-203">
                    Compartí tu{' '}
                    <span className="text-gradient-gold italic" data-id="element-204">
                      experiencia
                    </span>
                  </h2>
                  <p className="font-inter text-gray-400 text-sm sm:text-base" data-id="element-205">
                    Tu historia puede ayudar a otras personas a encontrar la
                    claridad que necesitan.
                  </p>
                </div>

                <form onSubmit={handleSubmit} className="flex flex-col gap-6" data-id="element-206">
                  {/* Star Rating */}
                  <div className="flex flex-col items-center gap-3 mb-2" data-id="element-207">
                    <span className="font-inter text-sm text-gray-400 uppercase tracking-widest" data-id="element-208">
                      Tu Calificación
                    </span>
                    <div className="flex gap-2" data-id="element-209">
                      {[1, 2, 3, 4, 5].map(star => <button key={star} type="button" onClick={() => setRating(star)} onMouseEnter={() => setHoverRating(star)} onMouseLeave={() => setHoverRating(0)} className="focus:outline-none transition-transform hover:scale-110" data-id="element-210">
                          <Star className={`w-8 h-8 sm:w-10 sm:h-10 transition-colors ${star <= (hoverRating || rating) ? 'fill-[#D4AF37] text-[#D4AF37]' : 'fill-transparent text-gray-600'}`} data-id="element-211" />
                        </button>)}
                    </div>
                  </div>

                  {/* Name Input */}
                  <div data-id="element-212">
                    <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Tu nombre o iniciales" required className="w-full bg-[#1a1a1a] border border-white/10 rounded-xl p-4 text-white font-inter placeholder:text-gray-600 focus:border-[#D4AF37]/50 focus:ring-1 focus:ring-[#D4AF37]/50 outline-none transition-all" data-id="element-213" />
                  </div>

                  {/* Review Textarea */}
                  <div data-id="element-214">
                    <textarea value={review} onChange={e => setReview(e.target.value)} placeholder="¿Cómo te ayudó la limpia? Contanos tu historia..." required rows={5} className="w-full bg-[#1a1a1a] border border-white/10 rounded-xl p-4 text-white font-inter placeholder:text-gray-600 focus:border-[#D4AF37]/50 focus:ring-1 focus:ring-[#D4AF37]/50 outline-none transition-all resize-none" data-id="element-215" />
                  </div>

                  {/* Submit Button */}
                  <button type="submit" className="w-full bg-gradient-to-r from-[#B8860B] via-[#D4AF37] to-[#B8860B] text-black font-inter font-bold text-lg py-4 rounded-xl shadow-[0_0_20px_rgba(212,175,55,0.2)] hover:shadow-[0_0_30px_rgba(212,175,55,0.4)] transition-all duration-300 uppercase tracking-wide mt-2" data-id="element-216">
                    Enviar Testimonio
                  </button>
                </form>
              </>}
          </div>
        </motion.div>
      </div>
    </section>;
}